import { c as _c } from "react/compiler-runtime";
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { Status } from '@systemeio/components';
import { GrowthbookFlagsEnum } from 'growthbook/types';
import { SubscriptionStatusEnum } from 'modules/payment/subscriptions/enums/subscription-status-enum';
import SettingsLayout from 'modules/profile/components/settings-layout';
import { settingsMenuLocoKeys } from 'modules/profile/constants/settings-menu-loco-keys';
import { MANAGE_SUBSCRIPTIONS_API } from 'modules/profile/manage-subscriptions/api/cancel-subscriptions-api';
import CancelSubscriptionModal from 'modules/profile/manage-subscriptions/components/cancel-subscription-modal';
import UpdateSubscriptionFieldsModal from 'modules/profile/manage-subscriptions/components/update-subscription-fields-modal';
import { ManageSubscriptionsLoco } from 'modules/profile/manage-subscriptions/constants/manage-subscriptions-loco';
import { SubscriptionStatusUiEnum } from 'modules/profile/manage-subscriptions/enums/subscription-status-ui';
import { useManageSubscriptions } from 'modules/profile/manage-subscriptions/hooks/use-manage-subscriptions';
import { ManageSubscriptionsInterface } from 'modules/profile/manage-subscriptions/types/manage-subscriptions-interface';
import { getSubscriptionStatus } from 'modules/profile/manage-subscriptions/utils/get-subscription-status';
import { NextPage } from 'next';
import React from 'react';
import { Tooltip } from 'shared/components';
import { RelativeTime } from 'shared/components/relative-time';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import { PricePlanTooltip } from 'shared/components/tooltip/price-plan-tooltip';
import { pageRoute } from 'shared/constants/routes.constants';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useUpdateData } from 'shared/hooks/use-update-data';
import useUser from 'shared/hooks/use-user';
import { usePagination } from 'shared/route-query/hooks/use-pagination';
import { dateTimeFormat } from 'shared/utils/date-time-format';
import { getBaseServerSideProps } from 'shared/utils/get-base-server-side-props';
import { getPageRoute } from 'shared/utils/get-dynamic-page-route';
const ManageSubscriptions: NextPage = () => {
  const $ = _c(78);
  const {
    t
  } = useLocoTranslation();
  const {
    user
  } = useUser();
  const {
    setPagination,
    pagination,
    setLimit,
    limit
  } = usePagination();
  const subscriptionInvoicesIsOn = useFeatureIsOn(GrowthbookFlagsEnum.SubscriptionInvoices);
  let t0;
  if ($[0] !== t || $[1] !== user?.dateFormat || $[2] !== user?.timeFormat || $[3] !== user?.timezone) {
    t0 = subscription => {
      const status = getSubscriptionStatus(subscription);
      if (status === SubscriptionStatusUiEnum.active) {
        return t("global.active");
      }
      if (status === SubscriptionStatusUiEnum.cancelled) {
        const deactivatedAt = subscription.subscriptionItems?.[0]?.deactivatedAt;
        if (deactivatedAt) {
          return `${t("global.cancelled")} - ${dateTimeFormat(deactivatedAt, {
            timeFormat: user?.timeFormat,
            dateFormat: user?.dateFormat,
            timeZone: user?.timezone
          })}`;
        }
        return t("global.cancelled");
      }
      if (status === SubscriptionStatusUiEnum.canceling) {
        return t("global.canceling");
      }
      if (status === SubscriptionStatusUiEnum.completed) {
        return t("dashboard.subscriptions.subscription_completed-2");
      }
    };
    $[0] = t;
    $[1] = user?.dateFormat;
    $[2] = user?.timeFormat;
    $[3] = user?.timezone;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const getStatusLabel = t0;
  let t1;
  if ($[5] !== t) {
    t1 = t("dashboard.subscriptions.title_plural");
    $[5] = t;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== t1) {
    t2 = {
      key: "subscriptionItems",
      header: t1,
      widthPercent: 30,
      onRender: _temp
    };
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t) {
    t3 = t("global.status");
    $[9] = t;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== getStatusLabel || $[12] !== t) {
    t4 = subscription_1 => {
      const status_0 = getSubscriptionStatus(subscription_1);
      const pill = <Status color={status_0 === SubscriptionStatusUiEnum.cancelled ? "error" : status_0 === SubscriptionStatusUiEnum.canceling ? "warning" : "active"} size="md">{getStatusLabel(subscription_1)}</Status>;
      return status_0 === SubscriptionStatusUiEnum.completed ? <Tooltip label={t("dashboard.subscriptions.subscription_completed")}>{pill}</Tooltip> : pill;
    };
    $[11] = getStatusLabel;
    $[12] = t;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t3 || $[15] !== t4) {
    t5 = {
      key: "status",
      header: t3,
      widthPercent: 40,
      onRender: t4
    };
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== t) {
    t6 = t("dashboard.subscriptions.date");
    $[17] = t;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t6) {
    t7 = {
      key: "createdAt",
      header: t6,
      widthPercent: 30,
      onRender: _temp2
    };
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t2 || $[22] !== t5 || $[23] !== t7) {
    t8 = [t2, t5, t7];
    $[21] = t2;
    $[22] = t5;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  const manageSubscriptionsColumns = t8;
  let t9;
  if ($[25] !== limit || $[26] !== pagination) {
    t9 = {
      limit,
      pagination
    };
    $[25] = limit;
    $[26] = pagination;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  const {
    data: subscriptions,
    mutate
  } = useManageSubscriptions(t9);
  let t10;
  if ($[28] !== setPagination) {
    t10 = {
      setPagination,
      api: MANAGE_SUBSCRIPTIONS_API
    };
    $[28] = setPagination;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  const updateData = useUpdateData(t10);
  let t11;
  if ($[30] !== mutate || $[31] !== subscriptions || $[32] !== updateData) {
    t11 = async subscriptionItemId => {
      await updateData(false, undefined, {
        mutationData: subscriptions,
        onMutate: async () => {
          await mutate(data => {
            if (data) {
              return {
                items: data.items.map(item => {
                  const subscriptionItem = item.subscriptionItems.find(el => el.id === subscriptionItemId);
                  if (subscriptionItem) {
                    item = {
                      ...item,
                      subscriptionItems: item.subscriptionItems.map(el_0 => {
                        if (el_0 === subscriptionItem) {
                          return {
                            ...el_0,
                            status: SubscriptionStatusEnum.cancelled
                          };
                        } else {
                          return el_0;
                        }
                      })
                    };
                  }
                  return item;
                }),
                hasMore: data.hasMore
              };
            }
          }, false);
        }
      });
    };
    $[30] = mutate;
    $[31] = subscriptions;
    $[32] = updateData;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  const onUnsubscribe = t11;
  let t12;
  if ($[34] !== t) {
    t12 = t(settingsMenuLocoKeys.manage_subscriptions);
    $[34] = t;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  let t13;
  if ($[36] !== t12) {
    t13 = [{
      caption: t12,
      isStatic: true
    }];
    $[36] = t12;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  let t14;
  if ($[38] !== t) {
    t14 = t("dashboard.settings.manage_subscriptions.cancel_subscription");
    $[38] = t;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  let t15;
  if ($[40] !== onUnsubscribe) {
    t15 = (opened, onClose, subscription_4, key) => <CancelSubscriptionModal key={key} subscription={subscription_4} opened={opened} onClose={onClose} onUnsubscribe={onUnsubscribe} />;
    $[40] = onUnsubscribe;
    $[41] = t15;
  } else {
    t15 = $[41];
  }
  let t16;
  if ($[42] !== t14 || $[43] !== t15) {
    t16 = {
      name: "cancel-subscription",
      shouldRender: _temp3,
      caption: t14,
      onActionRender: t15
    };
    $[42] = t14;
    $[43] = t15;
    $[44] = t16;
  } else {
    t16 = $[44];
  }
  let t17;
  if ($[45] !== t) {
    t17 = t("dashboard.settings.manage_subscriptions.update_information");
    $[45] = t;
    $[46] = t17;
  } else {
    t17 = $[46];
  }
  let t18;
  if ($[47] !== t17) {
    t18 = {
      name: "update-information",
      shouldRender: _temp4,
      caption: t17,
      onActionRender: _temp5
    };
    $[47] = t17;
    $[48] = t18;
  } else {
    t18 = $[48];
  }
  let t19;
  if ($[49] !== t16 || $[50] !== t18) {
    t19 = [t16, t18];
    $[49] = t16;
    $[50] = t18;
    $[51] = t19;
  } else {
    t19 = $[51];
  }
  let t20;
  if ($[52] !== subscriptionInvoicesIsOn) {
    t20 = () => subscriptionInvoicesIsOn;
    $[52] = subscriptionInvoicesIsOn;
    $[53] = t20;
  } else {
    t20 = $[53];
  }
  let t21;
  if ($[54] !== t) {
    t21 = t("dashboard.settings.manage_subscriptions.view_invoices");
    $[54] = t;
    $[55] = t21;
  } else {
    t21 = $[55];
  }
  let t22;
  if ($[56] !== t20 || $[57] !== t21) {
    t22 = [{
      name: "view-invoices",
      shouldRender: t20,
      caption: t21,
      setHref: _temp6
    }];
    $[56] = t20;
    $[57] = t21;
    $[58] = t22;
  } else {
    t22 = $[58];
  }
  let t23;
  if ($[59] !== t19 || $[60] !== t22) {
    t23 = {
      custom: t19,
      openLink: t22
    };
    $[59] = t19;
    $[60] = t22;
    $[61] = t23;
  } else {
    t23 = $[61];
  }
  let t24;
  if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = ["custom", "openLink"];
    $[62] = t24;
  } else {
    t24 = $[62];
  }
  let t25;
  if ($[63] !== limit || $[64] !== setLimit) {
    t25 = {
      limit,
      setLimit
    };
    $[63] = limit;
    $[64] = setLimit;
    $[65] = t25;
  } else {
    t25 = $[65];
  }
  let t26;
  if ($[66] !== pagination || $[67] !== setPagination) {
    t26 = {
      pagination,
      setPagination
    };
    $[66] = pagination;
    $[67] = setPagination;
    $[68] = t26;
  } else {
    t26 = $[68];
  }
  let t27;
  if ($[69] !== manageSubscriptionsColumns || $[70] !== subscriptions || $[71] !== t23 || $[72] !== t25 || $[73] !== t26) {
    t27 = <Table actions={t23} actionsOrder={t24} data={subscriptions} columns={manageSubscriptionsColumns} limiter={t25} paginator={t26} />;
    $[69] = manageSubscriptionsColumns;
    $[70] = subscriptions;
    $[71] = t23;
    $[72] = t25;
    $[73] = t26;
    $[74] = t27;
  } else {
    t27 = $[74];
  }
  let t28;
  if ($[75] !== t13 || $[76] !== t27) {
    t28 = <SettingsLayout needSave={false} titles={t13}>{t27}</SettingsLayout>;
    $[75] = t13;
    $[76] = t27;
    $[77] = t28;
  } else {
    t28 = $[77];
  }
  return t28;
};
export const getServerSideProps = getBaseServerSideProps(ManageSubscriptionsLoco, 'global.settings');
export default ManageSubscriptions;
function _temp(subscription_0) {
  return <PricePlanTooltip pricePlan={subscription_0.subscriptionItems?.[0]?.orderItem.pricePlan || null} hiddenInfo={true}><span className="cursor-pointer">{subscription_0.subscriptionItems?.[0]?.orderItem.pricePlan?.name}</span></PricePlanTooltip>;
}
function _temp2(subscription_2) {
  return <span><RelativeTime time={subscription_2.createdAt} /></span>;
}
function _temp3(subscription_3) {
  return getSubscriptionStatus(subscription_3) === SubscriptionStatusUiEnum.active;
}
function _temp4(subscription_5) {
  return getSubscriptionStatus(subscription_5) === SubscriptionStatusUiEnum.active;
}
function _temp5(opened_0, onClose_0, subscription_6, key_0) {
  return <UpdateSubscriptionFieldsModal opened={opened_0} onClose={onClose_0} subscriptionId={subscription_6.subscriptionItems?.[0]?.id || 0} key={key_0} />;
}
function _temp6(subscription_7) {
  return getPageRoute(pageRoute.ProfileManageSubscriptionInvoices, {
    subscriptionId: subscription_7.id
  });
}